module.exports = __webpack_public_path__ + "static/media/blog16.751b7f7e.svg";